var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconUploadAudio = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", null,
                React.createElement("g", null,
                    React.createElement("path", { d: "M22.7,4.4v7" }),
                    React.createElement("path", { d: "M19.2,7.9h7" })),
                React.createElement("g", null,
                    React.createElement("path", { d: "M9.7,23.4v-9.4l8.6-1.4v9.4" }),
                    React.createElement("path", { d: "M9.7,23.4c0,1.2-1,2.2-2.2,2.2s-2.2-1-2.2-2.2,1-2.2,2.2-2.2,2.2,1,2.2,2.2h0Z" }),
                    React.createElement("path", { d: "M18.3,22c0,1.2-1,2.2-2.2,2.2s-2.2-1-2.2-2.2,1-2.2,2.2-2.2h0c1.2,0,2.2,1,2.2,2.2s0,0,0,0Z" }))))));
});
export default IconUploadAudio;
//# sourceMappingURL=IconUploadAudio.js.map